module.exports = __webpack_public_path__ + "img/menu-close.1226d0ea.svg";